var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.51147 15.3414c0 .4295.3352.838.90085.838.2933 0 .53421-.1571.7542-.3352l1.36157-1.1523v9.9932c0 1.4664.8695 2.3149 2.36751 2.3149h14.1725c1.4876 0 2.3568-.8485 2.3568-2.3149v-10.0665l1.4561 1.2256c.2095.1781.4505.3352.7438.3352.4924 0 .8903-.3038.8903-.8066 0-.3142-.1046-.5237-.3248-.7123-5.85-4.9193-5.1542-4.3338-10.9044-9.16556-.7749-.65992-1.7386-.65992-2.5243 0l-10.91493 9.16556c-.23045.1886-.3352.44-.3352.6809zm5.74011 9.9722c-.6704 0-1.03677-.3771-1.03677-1.058v-10.9778l7.43709-6.23255c.2306-.2095.5131-.2095.7438 0l7.3428 6.15925v11.0511c0 .6809-.3667 1.058-1.0264 1.058-4.9649 0-8.4201 0-13.46052 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 19c0-.5523.4477-1 1-1h4c.5523 0 1 .4477 1 1v7h-6z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 9.83069c-.946-.79524-1.7461-1.46759-2.9891-2.51202.0895-.74292.7221-1.31867 1.4891-1.31867.8284 0 1.5.67157 1.5 1.5z",
    opacity: 0.6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLight);
export default __webpack_public_path__ + "static/media/Home-Light.cafa79f41e1e63b069d1b16c27c569fa.svg";
export { ForwardRef as ReactComponent };